<template>
	<div class="h-panel-body padding font-bold">
		<div class="h-panel-bar">
			<span class="h-panel-title">签约社区</span>
			<!-- <div class="hbtnbox">
				<button class="h-btn h-btn-blue">导出</button>
				<button class="h-btn">打印</button>
			</div> -->
		</div>

		<div class="topselectbox">
			  
			<div style="padding-left:10px"> 
				<a-input placeholder="社区名称" style="width:150px;" v-model="searchName"  />
                &nbsp;  
				<a-button type="primary" style="margin-left:20px;" @click="searchList()">
					查询
				</a-button>
			</div>
		</div>  
	  
		<div class="emtablebox"> 
            <Table :datas="dataList" :height="400" :border="true">
				<TableItem title="社区名称" prop="name"  />
				<TableItem title="所属地区" align="center" prop="address"   />
				<TableItem title="负责人" prop="personName" align="center"  />
				<TableItem title="负责人手机" align="center" prop="phone"  />  
				<TableItem title="关联商家" align="center"  >
					<template #default="{ data }">
						<span style="color:#1890ff;margin-right:10px;cursor: pointer;border-bottom:1px solid" @click="businessesClick(data.id)"  >{{
							'关联商家'+'('+data.businessesCnt+')'
						}}</span>
					</template>
				</TableItem>
                <TableItem title="关联店铺" align="center"  >
					<template #default="{ data }">
						<span style="color:#1890ff;margin-right:10px;cursor: pointer;border-bottom:1px solid" @click="storeClick(data.id)">{{
							'关联店铺'+'('+data.storeCnt+')'
						}}</span>
					</template>
				</TableItem>

				<TableItem title="账套用户"   align="center"  >
					<template #default="{ data }"> 
						<span v-if='!data.bindUser' style="color:green;margin-right:10px;cursor: pointer;" @click="bindUserClick(data.id)">创建用户</span> 
						 <span v-else style="margin-right:10px; "  >{{data.phone}}</span> 
					</template>
				</TableItem>
				<template #empty>
					暂无数据
				</template>
			</Table>

			<div class="yema" v-show="dataList.length>0">
				<a-pagination
					v-model="current"
					:total="total"
					:page-size="pageSize">
					<template slot="buildOptionText" slot-scope="props">
					<span v-if="props.value !== '50'">{{ props.value }}条/页</span>
					<span v-if="props.value === '50'">全部</span>
					</template>
				</a-pagination>
			</div>
		</div>

        <a-drawer title="关联商家列表" width="500" :closable="false" :visible="busVisible" @close="onBusClose">
            <div class="drawerTable">
				<Table :datas="busTableList" :height="400" :border="true">
                    <TableItem title="商家名称" prop="name"  /> 
                    <TableItem title="状态" align="center" :width="150">
                        <template #default="{ data }">
                            <span style="color:green;margin-right:10px;cursor: pointer;" v-if="data.status == 1">{{
                                '正常'
                            }}</span>
                            <span style="color:#999;margin-right:10px;cursor: pointer;" v-else>{{ '禁用' }}</span>
                            
                        </template>
                    </TableItem>
                    <template #empty>
                        暂无数据
                    </template>
                </Table>
                <div class="yema" v-show="busTableList.length>0">
                    <a-pagination
                        v-model="busCurrent"
                        :total="busTotal"
                        :page-size="busPageSize">
                        <template slot="buildOptionText" slot-scope="props">
                            <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                            <span v-if="props.value === '50'">全部</span>
                        </template>
                    </a-pagination>
                </div>
            </div>
        </a-drawer>
        <a-drawer title="关联店铺列表" width="500" :closable="false" :visible="storeVisible" @close="onStoreClose">
            <div class="drawerTable">
				<Table :datas="storeTableList" :height="400" :border="true">
                    <TableItem title="店铺名称" prop="name"  /> 
                    <TableItem title="状态" align="center" :width="150">
                        <template #default="{ data }">
                            <span style="color:green;margin-right:10px;cursor: pointer;" v-if="data.status == 1">{{
                                '正常'
                            }}</span>
                            <span style="color:#999;margin-right:10px;cursor: pointer;" v-else>{{ '禁用' }}</span>
                            
                        </template>
                    </TableItem>
                    <template #empty>
                        暂无数据
                    </template>
                </Table>
                <div class="yema" v-show="storeTableList.length>0">
                    <a-pagination
                        v-model="storeCurrent"
                        :total="storeTotal"
                        :page-size="storePageSize">
                        <template slot="buildOptionText" slot-scope="props">
                            <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                            <span v-if="props.value === '50'">全部</span>
                        </template>
                    </a-pagination>
                </div>
            </div>
        </a-drawer>

		<a-modal title="创建账套用户" :visible="bindUserVisible" :confirm-loading="confirmLoading" @ok="handleBindUser()" @cancel="onbindUserlose"
			cancelText="取消" okText="确认">
			<ul class="newbindUser">
				<li>
					<span>负责人姓名</span>
					<a-input style="width:280px" placeholder="请输入负责人姓名" v-model="newUser.personName" />
				</li> 
				<li>
					<span>负责人手机：</span>
					<a-input style="width:280px" placeholder="请输入手机号，作为登录账号" v-model="newUser.phone" />
				</li> 
				<li>
					<span>密码：</span>
					<a-input style="width:280px" type="password" placeholder="请输入密码" v-model="newUser.pwd" />
				</li>
				<li>
					<span>再次输入密码：</span>
					<a-input style="width:280px" type="password" placeholder="请再次输入密码" v-model="newUser.pwd2" />
				</li>
			</ul>
		</a-modal>
	</div>
</template>

<script>
  
import { mapState } from 'vuex';
export default {
	name: "signCommunity",
	data() {
		return {
			dataList: [],     
			datas:[],   
			current: 1, //页码
			pageSize: 10,
			total: 50,
            searchName:'',
			confirmLoading:false,
            busTableList:[],
            storeTableList:[],
            busVisible:false,
            storeVisible:false,
            busCurrent:1,
            busTotal:0,
            busPageSize:50,
            storeCurrent:1,
            storeTotal:0,
            storePageSize:50,
			bindUserVisible:false,
			newUser:{},
			newUserCommunityId:-1
		}
	},
	computed: {
		...mapState(['User', 'currentAccountSets']),
		date() {
			return moment(this.accountDate);
		}
	},
	methods: {
		  
        //查询
        searchList(){
            var that=this;
            var parmas = { 
                current:that.current,
				size:that.pageSize,
				name: that.searchName 
			}
            this.$api.community.list(parmas).then(data => {
                if(data.code==200){
                    that.dataList = data.data.records
                    that.current = data.data.current;
					that.total = data.data.pages;
                }
                console.log(data);
            });
        },
        busList(communityId){
            var that=this;
            var parmas = { 
                current:that.busCurrent,
				size:that.busSize,
                communityId:communityId
			}
            this.$api.community.buslist(parmas).then(data =>{
                 if(data.code==200){
                    that.busTableList = data.data.records
                    that.busCurrent = data.data.current;
					that.busTotal = data.data.pages;
                }
            })
        },
        storeList(communityId){
            var that=this;
            var parmas = { 
                current:that.storeCurrent,
				size:that.storeSize,
                communityId:communityId
			}
            this.$api.community.storeList(parmas).then(data =>{
                if(data.code==200){
                    that.storeTableList = data.data.records
                    that.storeCurrent = data.data.current;
					that.storeTotal = data.data.pages;
                }
            })
        },
        businessesClick(communityId){
            this.busList(communityId);
            this.busVisible=true;

        },
        storeClick(communityId){
            this.storeList(communityId);
            this.storeVisible=true;
        },
		bindUserClick(communityId){
			this.newUserCommunityId = communityId;
			this.bindUserVisible=true; 
		},
		//保存新用户
		handleBindUser(){
			var that=this;
			const regex = /^1[3456789]\d{9}$/;
			if(!regex.test(that.newUser.phone)){
				that.$message.error('手机号格式错误');
				return;
			}
			if(that.newUser.pwd==undefined||that.newUser.pwd==''){
				that.$message.error('请输入密码');
				return;
			}
			if(that.newUser.pwd!=that.newUser.pwd2){
				that.$message.error('两次密码输入不一致');
				return;
			}
			var params={
				id:that.newUserCommunityId,
				personName:that.newUser.personName,
				phone:that.newUser.phone,
				password:that.newUser.pwd,
			};
			console.log('请求参数：'); 
			console.log(params);
			 this.$api.community.bindNewUser(params).then(res=>{
				if (res.code == 200) { 
					this.bindUserVisible = false;
					this.searchList();
					this.$message.success('绑定成功！'); 
				} else {
					this.$message.error('操作失败');
				}
			 })
		},
        onBusClose(){
            this.busVisible=false;
        },
        onStoreClose(){
            this.storeVisible=false;
        },
		onbindUserlose(){
			this.bindUserVisible=false; 
			this.newUser={}
			this.newUserCommunityId=-1;
		}
		
	},

	mounted() { 
		//获取 
		this.searchList();
	}
}
</script>


<style lang="less" scoped>
.h-row>div>div {
	padding: 8px;
	border-radius: 5px;
	text-align: center;
	font-size: 20px;
	color: #000;
}

.period {
	border-radius: 3px;
	text-align: center;
	line-height: 54px;
	border: 1px solid @primary-color;
	white-space: nowrap;
	overflow: hidden;
	box-sizing: border-box;
	height: 80px;

	&:hover {
		cursor: pointer;
		box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
	}

	.month-header {
		height: 25px;
		margin: -8px -8px 0 -8px;
	}

	&.completed {
		.month-header {
			background-color: @gray1-color !important;
			line-height: 20px;
		}

		border-color: @gray1-color;

		color: #a2a2a2;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}

	&.disable {
		opacity: 0.4;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}


}

.topselectbox {
	padding-top: 10px;
	padding-left: 10px;
	overflow: hidden;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.topselectbox .depselect {
	float: left;
	padding-left: 10px;
	padding-top: 10px;
	display: flex;
	justify-content: left;
	align-items: center;
	font-weight: normal;
}

.topselectbox .depselect span {}

.topselectbox .depselect .bmselect {
	width: 160px;
}

.topselectbox .depselect02 {
	padding-top: 10px;
	float: left;
	display: flex;
	justify-content: left;
	align-items: center;
}

.topselectbox .depselect02 span {}

.topselectbox .depselect02 .bmselect {
	width: 160px;
}

.emtablebox {
	padding-top: 20px;
	padding-left: 18px;
	min-height: 650px;
}

.emtablebox tbody {}

.emtablebox table tbody tr td {
	font-weight: normal !important;
	;
}

.yemabox {
	padding-top: 50px;
	padding-bottom: 30px;
}


.ziliaotable {}

.ziliaotable table {
	width: 100%
}

.ziliaotable table tr {
	width: 100%;
	display: flex;
	justify-content: left;
	align-items: center;
}

.ziliaotable table tr td {
	display: flex;
	padding-top: 10px;
	padding-bottom: 10px;
	justify-content: right;
	align-items: center;
	width: 100%;
}

.fiveonebox {
	padding-top: 20px;
	padding-bottom: 100px;
}

.fiveonebox h3 {
	padding-top: 20px;
	padding-bottom: 10px;
}

.datagridbox {
	padding-top: 20px;
}

.datagrid-htable {
	width: 100%;
}

.datagrid-htable tr td {
	border: 1px solid #ddd;
	text-align: center;
	padding-top: 10px;
	padding-bottom: 10px;
	vertical-align: middle;
}

.datagrid-htable tr.datagrid-header-row td {
	border: 1px solid #ddd;
	text-align: center;
	background: #f2f2f2;
}

.datagrid-htable tr td div {
	text-align: center;
}

.datagrid-htable .tbody02 {}

.datagrid-htable .tbody02 tr td {
	vertical-align: middle !important;
}

.datagrid-htable .tbody02 tr td span {
	padding-left: 5px;
	padding-top: 10px;
}

.newbindUser {}

.newbindUser li {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;
}
.newbindUser li span{
	width:120px;
}
.yema{ text-align:center; padding-top:30px;}
 
</style>
